class pinOpener extends HTMLElement {
  constructor() {
    super();
    if(window.matchMedia("(max-width: 1024px)").matches) {
      this.addEventListener('click', this.onClick.bind(this))
    }
  }

  onClick() {
    var pin_content = this.nextElementSibling;

    document.querySelector('pin-dialog').open(pin_content)
  }
}
class pinDialog extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'PIN-DIALOG') {
          this.hide();
      }
    });
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  open(data) {
    this.setAttribute("open", "")
    this.querySelector('.popup-content').innerHTML = data.innerHTML
  }

  hide() {
    this.removeAttribute("open");
    this.querySelector('.popup-content').innerHTML = "";
  }
}

customElements.define('pin-dialog', pinDialog)

customElements.define('pin-opener', pinOpener)